export const labelClass = "block text-sm font-medium text-gray-700 mb-1";

export const inputClass =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red";
